import React, { FunctionComponent, ReactNode } from 'react';
import Link from 'next/link';
import { Container, Row, Col } from 'react-bootstrap';
import LazyImage from '@views/components/lazy-image';
import { INTERNAL_ROUTES } from '@helpers/route';

import IconFacebook from '@views/static/fb.svg';
import IconYoutube from '@views/static/youtube.svg';

export interface IFooterProps {
  companyInfo: IFooterCompanyProps;
  supportLinks: IFooterLinkProps[];
  policyLinks: IFooterLinkProps[];
}

export interface IFooterCompanyProps {
  name: string;
  address: ReactNode;
  email: string;
  phone: string;
  link?: string | ReactNode;
  facebook?: string;
  zalo?: string;
  copyright?: string | ReactNode;
}

export interface IFooterLinkProps {
  key: string;
  url: string;
  text: string;
  external?: boolean;
}

const Footer: FunctionComponent<IFooterProps> = ({
  companyInfo,
  supportLinks,
  policyLinks,
}): JSX.Element => (
  <footer className="footer">
    <Container>
      <Row>
        <Col md={6} lg={5} className="mb-4">
          <div>
            <strong>{companyInfo.name}</strong> <br />
            {companyInfo.address} <br />
            <strong>
              Email:{' '}
              <a
                href={`mailto:${companyInfo.email}`}
                aria-label={companyInfo.email}
                title={companyInfo.email}
              >
                {companyInfo.email}
              </a>{' '}
              <br />
              Hotline:{' '}
              <a
                href={`tel:${companyInfo.phone}`}
                aria-label={companyInfo.phone}
                title={companyInfo.phone}
              >
                {companyInfo.phone}
              </a>
            </strong>
          </div>
        </Col>

        <Col md={6} lg={7}>
          <Row>
            <Col md={4} className="mb-4">
              <div>
                <strong>Về FAST</strong>
              </div>
              <ul className="list-unstyled">
                <li>
                  <a
                    href={INTERNAL_ROUTES.CONTACT}
                    aria-label="Giới thiệu FAST"
                    title="Giới thiệu FAST"
                  >
                    Giới thiệu FAST
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/vppfast"
                    target="_blank"
                    aria-label="Facebook"
                    title="Facebook"
                    rel="noopener noreferrer"
                  >
                    {/* <IconFacebook />  */}
                    <span>Facebook</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/channel/UC72Te7BpMRIOA8NiF52qXlQ/videos"
                    target="_blank"
                    aria-label="Youtube"
                    title="Youtube"
                    rel="noopener noreferrer"
                  >
                    {/* <IconYoutube />  */}
                    <span>Youtube</span>
                  </a>
                </li>
              </ul>
            </Col>
            <Col md={4} className="mb-4">
              <div>
                <strong>HỖ TRỢ KHÁCH HÀNG</strong>
              </div>
              <ul className="list-unstyled">
                {supportLinks.map(({ key, url, text, external }) => (
                  <li key={key}>
                    {!external ? (
                      <a href={url} aria-label={text} title={text}>
                        {text}
                      </a>
                    ) : (
                      <a
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={text}
                        title={text}
                      >
                        {text}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </Col>

            <Col md={4} className="mb-4">
              <div>
                <strong>CHÍNH SÁCH</strong>
              </div>
              <ul className="list-unstyled">
                {policyLinks.map(({ key, url, text }) => (
                  <li key={key}>
                    <a href={url} aria-label={text} title={text}>
                      {text}
                    </a>
                  </li>
                ))}
              </ul>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="align-items-center">
        <Col md={8}>{companyInfo.copyright}</Col>
        <Col md={4} className="text-right">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="http://online.gov.vn/Home/WebDetails/25827"
          >
            <LazyImage
              className="footer__image"
              src="/assets/bocongthuong.jpg"
              srcSet="/assets/bocongthuong@2x.jpg 2x, /assets/bocongthuong@3x.jpg 3x"
              alt="bocongthuong"
            />
          </a>
        </Col>
      </Row>
    </Container>
  </footer>
);

export default Footer;
